<template>
  <div>
    <div v-for="entry in getPageEntries()" :key="keyFunction(entry)">
      <component :is="componentName" v-bind="{ [dataAttributeName]: entry }" />
      <hr v-if="!isLastPageEntry(entry)" />
    </div>
    <div class="pagination-nav" v-if="this.dataList.length > this.entriesPerPage">
      <IconButton :disabled="previousDisabled" @click.native="previousPage" v-scroll-to="'#nav-col'">
        <font-awesome-icon icon="chevron-left" />
      </IconButton>
      &nbsp;
      <IconButton :disabled="nextDisabled" @click.native="nextPage" v-scroll-to="'#nav-col'">
        <font-awesome-icon icon="chevron-right" />
      </IconButton>
    </div>
  </div>
</template>

<script>
import IconButton from './IconButton.vue';

export default {
  name: 'Pagination',
  components: { IconButton },
  props: {
    entriesPerPage: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    componentName: {
      type: String,
      required: true,
    },
    dataAttributeName: {
      type: String,
      required: true,
    },
    dataList: {
      type: Array,
      required: true,
    },
    keyFunction: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    page: 1,
  }),
  computed: {
    previousDisabled() {
      return this.page === 1;
    },
    nextDisabled() {
      return this.page === this.pageCount;
    },
    pageCount() {
      return Math.ceil(this.dataList.length / this.entriesPerPage);
    },
  },
  methods: {
    previousPage() {
      if (this.page > 1) {
        this.$router.replace({ path: this.$route.path, query: { page: String(this.page - 1) } });
      }
    },
    nextPage() {
      if (this.page < this.pageCount) {
        this.$router.replace({ path: this.$route.path, query: { page: String(this.page + 1) } });
      }
    },
    getPageEntries() {
      const { entriesPerPage } = this.$props;
      const firstIndex = entriesPerPage * (this.page - 1);
      const lastIndex = entriesPerPage * this.page;
      return this.$props.dataList.slice(firstIndex, lastIndex);
    },
    isLastPageEntry(entry) {
      const pageEntries = this.getPageEntries();
      return pageEntries[pageEntries.length - 1] === entry;
    },
  },
  created() {
    const qPage = this.$route.query.page;
    if (Number(qPage) > this.pageCount) {
      this.page = this.pageCount;
    } else if (Number(qPage) < 1) {
      this.page = 1;
    } else {
      this.page = qPage ? Number(qPage) : 1;
    }
  },
  watch: {
    $route(to, from) {
      const qPage = to.query.page;
      if (Number(qPage) > this.pageCount) {
        this.page = this.pageCount;
      } else if (Number(qPage) < 1) {
        this.page = 1;
      } else {
        this.page = qPage ? Number(qPage) : 1;
      }
    },
  },
};
</script>

<style scoped>
.pagination-nav {
  padding: 0.5rem;
  text-align: center;
}
</style>
